export const BASE_POLICY_MODE = {
  Enforce: 'Enforce',
  Audit: 'Audit',
};

// Audit is the mode still being evaluated, so it reads as the cautionary one.
const BASE_POLICY_MODE_MAPPING = [
  { value: BASE_POLICY_MODE.Enforce, label: 'Enforce', color: '#7DFF92' },
  { value: BASE_POLICY_MODE.Audit, label: 'Audit', color: '#E0A23C' },
];

export const getBasePolicyModeLabel = value =>
  BASE_POLICY_MODE_MAPPING.find(item => item.value === value)?.label ??
  (value != null && value !== '' ? String(value).replace(/([a-z])([A-Z])/g, '$1 $2') : '');

export const getBasePolicyModeColor = value =>
  BASE_POLICY_MODE_MAPPING.find(item => item.value === value)?.color;

export const getBasePolicyModeOptions = () =>
  BASE_POLICY_MODE_MAPPING.map(({ value, label }) => ({ value, label }));
